import { __assign } from "tslib";
import React from 'react';
import { FabricChannel } from '../types';
import processEvent from './process-event';
import GenericAnalyticsListener from '../GenericAnalyticsListener';
export default function PeopleTeamsAnalyticsListener(props) {
    return (React.createElement(GenericAnalyticsListener, __assign({}, props, { channel: FabricChannel.peopleTeams, processEvent: processEvent })));
}
//# sourceMappingURL=PeopleTeamsAnalyticsListener.js.map